import { render, staticRenderFns } from "./SingleCompete.vue?vue&type=template&id=6ef941ea&scoped=true&"
import script from "./SingleCompete.vue?vue&type=script&lang=js&"
export * from "./SingleCompete.vue?vue&type=script&lang=js&"
import style0 from "./SingleCompete.vue?vue&type=style&index=0&id=6ef941ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef941ea",
  null
  
)

export default component.exports